import Navbar from "@/components/navigation/Navbar";
import { Button } from "@/components/ui/button";
import { config } from "@/puck/config";
import { Render } from "@measured/puck";
import { useParams, useNavigate } from "react-router-dom";
import "@measured/puck/puck.css";
import { SidebarTrigger } from "@/components/ui/sidebar";
import { useContext, useEffect, useState } from "react";
import { Page } from "@/type/common";
import AuthContext from "@/store/contexts/AuthContext";
import { Download, Pen, RefreshCcw, Trash } from "lucide-react";
import axios from "@/services/axios";
import EmptyPage from "@/components/pages/home/EmptyPage";

const Home = () => {
  const { page_id } = useParams<{ page_id: string }>();
  const { pages, isEditor } = useContext(AuthContext);
  const [currentPage, setCurrentPage] = useState<Page | undefined | null>(
    undefined
  );
  const navigate = useNavigate();

  useEffect(() => {
    setCurrentPage(pages.find((page) => page.id === page_id) || null);
  }, [page_id, pages]);

  if (currentPage === undefined) return null;

  return (
    <div className="flex h-screen w-full">
      <Navbar />
      {!currentPage === null && (
        <EmptyPage isEditor={isEditor} noPages={pages.length === 0} />
      )}
      {currentPage && (
        <div className="flex-1">
          <div className="flex justify-between p-4">
            <SidebarTrigger />
            <div className="flex gap-2">
              <Button
                size="icon"
                variant="outline"
                onClick={() => {
                  localStorage.removeItem("data-cache");
                  window.parent.postMessage({ type: "refresh" }, "*");
                }}
              >
                <RefreshCcw />
              </Button>
              <Button
                size="icon"
                variant="outline"
                onClick={async () => {
                  const url = await axios
                    .get(`/odash/pages/${page_id}/pdf`)
                    .then((e) => e.data)
                    .catch(() => null);
                  if (!url) return;
                  if (url) {
                    window.parent.postMessage(
                      { type: "openUrl", url: url.url },
                      "*"
                    );
                  }
                }}
              >
                <Download />
              </Button>

              {isEditor && (
                <Button
                  size="icon"
                  variant="outline"
                  onClick={() => navigate(`/${page_id}/edit`)}
                >
                  <Pen />
                </Button>
              )}
            </div>
          </div>
          {currentPage.content === null || currentPage.content.length === 0 ? (
            <EmptyPage isEditor={isEditor} />
          ) : (
            <Render config={config} data={currentPage} />
          )}
          <div className="h-4"></div>
        </div>
      )}
    </div>
  );
};

export default Home;
